import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { saveAs } from 'file-saver';
import { Toast } from "primereact/toast";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setPageData } from "store/actions";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"

const MyPlacementReport = () => {
    const dispatch = useDispatch();
    const { first, rows, totalRecords } = useSelector((state) => state.calendar.pagination);
    const [loading, setLoading] = useState(true);
    
    const userInfos = JSON.parse(sessionStorage.getItem("user-info"));
    const intialcompanyId = userInfos.user_details?.companies_data?.[0]?.company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);
    const handleCompanyChange = (company) => {
        if (company?.company_id) {
            const selectedId = company.company_id;
            setCompanyId(selectedId);

            const page = Math.floor(first / rows) + 1;
            // fetchMyPlacementReportData(page, selectedId);
        }
    };

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_number: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        candidate_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        candidate_email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        placement_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        days_to_close: { value: null, matchMode: FilterMatchMode.EQUALS },
        job_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    });
    document.title = "ATS - Reports"
    const [jobs,setJobs] = useState([])
    const toast = useRef(null);

    // const jobs = [
    //     { candidate: "Ajay Kumar", job_id: "Job-101", job_title: "Python Developer", contact: "Shweta Shashi", placement_date: "1/30/2025", status: "Active", no_of_days: 30, start_date: "2025-01-01", end_date: "2025-12-31", owner_id: "Hari" },
    //     { candidate: "Rahul Singh", job_id: "Job-102", job_title: "Frontend Developer", contact: "Ankita Mehra", placement_date: "2/15/2025", status: "On Hold", no_of_days: 20, start_date: "2025-02-01", end_date: "2025-10-31", owner_id: "Raj" },
    //     { candidate: "Priya Verma", job_id: "Job-103", job_title: "Backend Developer", contact: "Nisha Roy", placement_date: "3/01/2025", status: "Inactive", no_of_days: 40, start_date: "2025-03-01", end_date: "2025-11-30", owner_id: "Ravi" },
    //     { candidate: "Amit Sharma", job_id: "Job-104", job_title: "Software Engineer", contact: "Pooja Gupta", placement_date: "4/10/2025", status: "Active", no_of_days: 50, start_date: "2025-04-01", end_date: "2025-12-31", owner_id: "Neha" },
    //     { candidate: "Sanya Patel", job_id: "Job-105", job_title: "QA Engineer", contact: "Gaurav Tiwari", placement_date: "5/12/2025", status: "Active", no_of_days: 60, start_date: "2025-05-01", end_date: "2025-11-30", owner_id: "Ravi" },
    //     { candidate: "Vikas Sharma", job_id: "Job-106", job_title: "Project Manager", contact: "Seema Kapoor", placement_date: "6/20/2025", status: "On Hold", no_of_days: 35, start_date: "2025-06-01", end_date: "2025-12-31", owner_id: "Alok" },
    //     { candidate: "Aarti Gupta", job_id: "Job-107", job_title: "Data Analyst", contact: "Maya Singh", placement_date: "7/15/2025", status: "Inactive", no_of_days: 25, start_date: "2025-07-01", end_date: "2025-11-30", owner_id: "Alok" },
    //     { candidate: "Karan Yadav", job_id: "Job-108", job_title: "DevOps Engineer", contact: "Gita Kapoor", placement_date: "8/05/2025", status: "Active", no_of_days: 45, start_date: "2025-08-01", end_date: "2025-10-31", owner_id: "Ravi" },
    //     { candidate: "Shivani Verma", job_id: "Job-109", job_title: "HR Manager", contact: "Nina Sharma", placement_date: "9/25/2025", status: "On Hold", no_of_days: 30, start_date: "2025-09-01", end_date: "2025-12-31", owner_id: "Vikram" },
    //     { candidate: "Manish Kumar", job_id: "Job-110", job_title: "UX Designer", contact: "Mitali Desai", placement_date: "10/01/2025", status: "Active", no_of_days: 55, start_date: "2025-10-01", end_date: "2025-12-31", owner_id: "Hari" }
    // ];

    const [selectedJobs, setSelectedJobs] = useState([]);
    const dt = useRef(null); 

    const onSelectionChange = (e) => {
        setSelectedJobs(e.value);
    };

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const fetchMyPlacementReportData = async(page , companyId)=>{
        setLoading(true)
        try{
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/placement_report/?my_pipeline=true&page=${page}&size=${rows}`)
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/placement_report/?my_pipeline=true&page=${page}&size=${rows}&company_id=${companyId}`);
        const apiResponse = response?.data?.results 
        const transformedData = apiResponse.map((item)=>{
            return{
                id:item.id,
                job_id:item.job_number,
                job_title:item.job_title,
                candidate_name:item.candidate_name,
                candidate_email:item.candidate_email,
                placement_date:item.placement_date,
                days_to_close:item.days_to_close,
                start_date:item.job_start_date,
                end_date:item.job_end_date,
                user_id:item.user_id
            }
        })

        setJobs(apiResponse)
        setLoading(false)
        dispatch(setPageData({
                first: (page - 1) * rows,
                rows: rows,
                totalRecords: response?.data?.count || 0,
              }));
        }
        catch(error){
            console.log("error",error.message)
            setLoading(false)
        }
    }

    // useEffect(() =>{
    //     const page = Math.floor(first / rows) + 1;
    //     fetchMyPlacementReportData(page)
    // },[first,rows])

useEffect(() => {
    if (companyId) {
        const page = Math.floor(first / rows) + 1;
        fetchMyPlacementReportData(page, companyId);
    }
}, [first, rows, companyId]);

     const onPage = (e) => {
        const newPage = Math.floor(e.first / e.rows) + 1;
        dispatch(setPageData({
          first: e.first,
          rows: e.rows,
          totalRecords,
        }));
        // fetchMyPlacementReportData(newPage , companyId);
      };
    

  const exportPdf = () => {
    console.log("Starting PDF export...");

    // Check if jobs and selectedJobs are defined
    if (!jobs || !Array.isArray(jobs)) {
        console.error("Error: 'jobs' is undefined or not an array");
        if (toast.current) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Invalid data: jobs is not properly defined.',
                life: 4000
            });
        }
        return;
    }

    import("jspdf").then((jsPDF) => {
        console.log("jsPDF loaded successfully");
        import("jspdf-autotable").then(() => {
            console.log("jspdf-autotable loaded successfully");
            try {
                const doc = new jsPDF.default("landscape");
                const dataToExport = selectedJobs.length > 0 ? selectedJobs : jobs;

                console.log("Data to export:", dataToExport);

                if (dataToExport.length === 0) {
                    console.warn("No data to export, showing toast");
                    if (toast.current) {
                        toast.current.show({
                            severity: "info",
                            summary: "Info",
                            detail: "No rows selected, exporting all data to PDF.",
                            life: 3000,
                        });
                    }
                }

                const exportColumns = [
                    { title: "Candidate", dataKey: "candidate_name" },
                    { title: "Job ID", dataKey: "job_number" },
                    { title: "Job Title", dataKey: "job_title" },
                    { title: "Contact", dataKey: "candidate_email" },
                    { title: "Placement Date", dataKey: "placement_date" },
                    { title: "No of Days", dataKey: "days_to_close" },
                    { title: "Start Date", dataKey: "job_start_date" },
                    { title: "End Date", dataKey: "job_end_date" },
                    { title: "Recruiter Name", dataKey: "user_id" }
                ];

                const formattedData = dataToExport.map((item, index) => {
                    console.log(`Processing row ${index}:`, item);
                    const row = {};
                    exportColumns.forEach(col => {
                        row[col.dataKey] = item[col.dataKey] ?? '';
                    });
                    return row;
                });

                console.log("Formatted data:", formattedData);

                doc.autoTable({
                    columns: exportColumns,
                    body: formattedData.length > 0 ? formattedData : [{ candidate_name: "No data to export" }],
                    startY: 20,
                    styles: { fontSize: 8, cellPadding: 2 },
                    theme: "grid",
                    margin: { top: 10, left: 5, right: 5 },
                    columnStyles: { 0: { cellWidth: 30 } },
                });

                console.log("AutoTable generated, attempting to save PDF...");
                doc.save("jobs.pdf");
                console.log("PDF save triggered");
            } catch (error) {
                console.error("Error during PDF generation:", error);
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to generate PDF. Please try again.',
                        life: 4000
                    });
                }
            }
        }).catch((error) => {
            console.error('Error loading jspdf-autotable:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load PDF table library.',
                    life: 4000
                });
            }
        });
    }).catch((error) => {
        console.error('Error loading jsPDF:', error);
        if (toast.current) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to load PDF library.',
                life: 4000
            });
        }
    });
};

    const exportExcel = () => {
    import('xlsx').then((xlsx) => {
        // Use selectedJobs if there are selections, otherwise use all jobs
        const dataToExport = selectedJobs.length > 0 ? selectedJobs : jobs;
        
        // Define headers even if there's no data
        const headers = {
            Candidate: '',
            'Job ID': '',
            'Job Title': '',
            Contact: '',
            'Placement Date': '',
            Status: '',
            'No of Days': '',
            'Start Date': '',
            'End Date': '',
            'Recruiter Name': ''
        };

        // Format the data to ensure all fields are included
        const formattedData = dataToExport.length > 0 
            ? dataToExport.map(job => ({
                Candidate: job.candidate_name || '',
                'Job ID': job.job_id || '',
                'Job Title': job.job_title || '',
                Contact: job.candidate_email || '',
                'Placement Date': job.placement_date || '',
                Status: job.status || '',
                'No of Days': job.days_to_close || '',
                'Start Date': job.job_start_date || '',
                'End Date': job.job_end_date || '',
                'Recruiter Name': job.user_id || ''
            }))
            : [headers]; // Use headers as fallback for empty data

        const worksheet = xlsx.utils.json_to_sheet(formattedData);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        saveAsExcelFile(excelBuffer, selectedJobs.length > 0 ? 'selected_jobs' : 'all_jobs');
    }).catch((error) => {
        console.error('Error exporting to Excel:', error);
    });
};

    const saveAsExcelFile = (buffer, fileName) => {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], { type: EXCEL_TYPE });
        saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };

    const printFile = () => {
    const exportColumns = [
        { title: "Candidate", dataKey: "candidate_name" },
        { title: "Job ID", dataKey: "job_id" },
        { title: "Job Title", dataKey: "job_title" },
        { title: "Contact", dataKey: "candidate_email" },
        { title: "Placement Date", dataKey: "placement_date" },
        { title: "No of Days", dataKey: "days_to_close" },
        { title: "Start Date", dataKey: "job_start_date" },
        { title: "End Date", dataKey: "job_end_date" },
        { title: "Recruiter Name", dataKey: "user_id" }
    ];

    const dataToExport = selectedJobs.length > 0 ? selectedJobs : jobs;
    
    // Show toast notification if no rows are selected
    if (selectedJobs.length === 0 && toast.current) {
        toast.current.show({
            severity: 'info',
            summary: 'Info',
            detail: 'No rows selected, printing all data.',
            life: 3000
        });
    }

    // Generate table headers
    const tableHeaders = exportColumns
        .map(col => `<th style="border: 1px solid #ccc; padding: 10px; background-color: #f5f5f5; font-weight: bold;">${col.title}</th>`)
        .join('');

    // Generate table rows with data validation
    const tableRows = dataToExport.length > 0
        ? dataToExport
            .map(row => {
                if (!row) return ''; // Skip invalid rows
                return `<tr>${exportColumns
                    .map(col => `<td style="border: 1px solid #ccc; padding: 10px;">${row[col.dataKey] ?? '-'}</td>`)
                    .join('')}</tr>`;
            })
            .filter(row => row) // Remove empty rows
            .join('')
        : '<tr><td colspan="10" style="border: 1px solid #ccc; padding: 10px; text-align: center;">No data available</td></tr>';

    // Get current timestamp for report title
    const timestamp = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    const htmlContent = `
        <html>
        <head>
            <title>Placement Report - ${timestamp}</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    margin: 2cm;
                }
                table {
                    border-collapse: collapse;
                    width: 100%;
                    margin-top: 20px;
                }
                th, td {
                    border: 1px solid #ccc;
                    padding: 12px;
                    text-align: left;
                    font-size: 14px;
                }
                th {
                    background-color: #e6e6e6;
                    color: #333;
                }
                h2 {
                    text-align: center;
                    font-size: 20px;
                    margin-bottom: 20px;
                    color: #333;
                }
                @media print {
                    body {
                        margin: 1cm;
                    }
                    table {
                        page-break-inside: auto;
                    }
                    tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                }
            </style>
        </head>
        <body>
            <h2>Placement Report - ${timestamp}</h2>
            <table>
                <thead><tr>${tableHeaders}</tr></thead>
                <tbody>${tableRows}</tbody>
            </table>
        </body>
        </html>
    `;

    try {
        const printWindow = window.open('', '_blank', 'height=600,width=900');
        if (!printWindow) {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to open print window. Please allow pop-ups.',
                    life: 4000
                });
            }
            return;
        }
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        setTimeout(() => printWindow.close(), 500); // Delay closing to ensure print dialog appears
    } catch (error) {
        console.error('Error during printing:', error);
        if (toast.current) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'An error occurred while printing.',
                life: 4000
            });
        }
    }
};

    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
                
                    <Container fluid={true}>
                        <div className="page-title-box actjobbread">
                            <Row className="align-items-center actjobsum">
                                <Col sm={6} md={6} lg={8}>
                                    <h1 className="page-title">My Placement Report</h1>
                                </Col>
                                <Col sm={6} md={6} lg={4}>
                                    <div className="allbtns d-flex gap-2 justify-content-end">
                                        <Button 
                                            type="button" 
                                            icon="pi pi-file" 
                                            rounded 
                                            onClick={() => exportCSV(selectedJobs.length > 0)} 
                                            tooltip={selectedJobs.length > 0 ? "Export Selected to CSV" : "Export All to CSV"} 
                                            tooltipOptions={{ position: 'left' }} 
                                            className="csvbtn" 
                                        />
                                        <Button 
                                            type="button" 
                                            icon="pi pi-file-excel" 
                                            severity="success" 
                                            rounded 
                                            onClick={exportExcel} 
                                            tooltip={selectedJobs.length > 0 ? "Export Selected to XLS" : "Export All to XLS"} 
                                            tooltipOptions={{ position: 'top' }} 
                                            className="xlsbtn"
                                        />
                                        <Button 
                                            type="button" 
                                            icon="pi pi-file-pdf" 
                                            severity="warning" 
                                            rounded 
                                            onClick={exportPdf} 
                                            tooltip={selectedJobs.length > 0 ? "Export Selected to PDF" : "Export All to PDF"} 
                                            tooltipOptions={{ position: 'bottom' }} 
                                            className="pdfbtn" 
                                        />
                                        <Button 
                                            type="button" 
                                            icon="pi pi-print" 
                                            severity="warning" 
                                            rounded 
                                            tooltip="Print" 
                                            className="printbtn" 
                                            tooltipOptions={{ position: 'bottom' }}
                                            onClick={printFile}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6}>
                                    <h1 className="page-title mb-4"> </h1>
                                </Col>
                                <Col xxl={6}>
                                    <div className="d-flex justify-content-end mt-2">
                                        <label className="mt-2 me-2">Select Company</label>
                                    <div className="mb-2 me-2" style={{ width: "170px" }}>
                                        <CompanySelector onCompanyChange={handleCompanyChange} />
                                    </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={12}>
                                    <section className="job-datatable-section">
                                        <div className="card1 mt-3 mb-4 actjobsumtable">
                                            {loading ? (
                                                <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                                                ) : (

                                                <DataTable
                                                    ref={dt}
                                                    value={jobs}
                                                    tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                                
                                                    rows={rows}
                                                    first={first}
                                                    paginator
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                                    onPage={onPage}
                                                    dataKey="id"
                                                    filters={filters}
                                                    filterDisplay="row"
                                                    // loading={loading}
                                                    globalFilterFields={['candidate_name', 'job_id', 'job_title', 'candidate_email', 'placement_date', 'no_of_days', 'job_start_date', 'job_end_date', 'user_id']}
                                                    selection={selectedJobs}
                                                    onSelectionChange={onSelectionChange}
                                                    showGridlines
                                                    responsiveLayout="scroll"
                                                    selectionMode="checkbox"
                                                id="MyPlaceMentReportTable"
                                                >
                                                {/* <Column selectionMode="multiple" style={{ width: '3em' }} /> */}
                                                    <Column field="candidate_name" header="Candidate" sortable filter filterPlaceholder="Candidate" />
                                                    <Column field="job_number" header="Job ID" sortable filter filterPlaceholder="Job ID" />
                                                    <Column field="job_title" header="Job Title" className="wrap-word-column" sortable filter filterPlaceholder="Job Title" />
                                                    <Column field="candidate_email" header="Contact" sortable filter filterPlaceholder="Contact" />
                                                    <Column field="placement_date" header="Placement Date" sortable filter filterPlaceholder=" Placement Date" />
                                                    <Column field="days_to_close" header="No. of Days" sortable filter filterPlaceholder="No. of Days" />
                                                    <Column field="job_start_date" header="Start Date" sortable filter filterPlaceholder="Start Date" />
                                                    <Column field="job_end_date" header="End Date" sortable filter filterPlaceholder=" End Date" />
                                                    <Column field="user_id" header="Recruiter Name" sortable filter filterPlaceholder="Recruiter Name" />
                                                </DataTable> 
                                            )}
                                        </div>
                                    </section>
                                </Col>
                            </Row>
                        </div>
                    </Container>
               
            </div>
        </React.Fragment>
    );
};

export default MyPlacementReport;